import React from "react";
import { useLocation } from "react-router-dom";

function UpgradePlan() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const key1 = queryParams.get("key1");
  const key2 = queryParams.get("key2");

  return (
    <div className="container mb-5 mt-5 flex justify-center bg-[#e6ebf4] py-8">
      <div className="w-full max-w-xl rounded-lg border-0 bg-white p-8 shadow-[5px_6px_6px_2px_#e9ecef]">
        <div>
          <h4 className="text-[23px] font-semibold text-brand-forest">Upgrade your plan</h4>
          <p className="text-base font-medium text-[#b1b6bd]">
            Please make the payment to start enjoying all the features of our
            premium plan as soon as possible
          </p>
        </div>

        <div className="mt-4 flex justify-between rounded border-2 border-[#304FFE] bg-[#f2f5ff] p-3">
          <div className="flex flex-row items-center">
            <img
              src="https://i.imgur.com/S17BrTx.png"
              className="rounded"
              alt="Plan"
              width="60"
            />
            <div className="ml-4 flex flex-col">
              <span className="text-xl font-medium text-brand-forest">{key1}</span>
              <span className="text-[#aba4a4]">CHANGE PLAN</span>
            </div>
          </div>
          <div className="flex flex-row items-center">
            <sup className="text-base font-bold text-[#6b6b6f]">$</sup>
            <span className="mx-1 text-5xl font-medium text-brand-forest">{key2}</span>
            {key2 !== "Free" && (
              <span className="mt-5 text-xl font-bold text-[#6b6b6f]">/ year</span>
            )}
          </div>
        </div>

        <span className="mt-5 block text-[22px] font-medium text-brand-forest">
          Payment details
        </span>

        <div className="mt-4 flex items-center justify-between rounded bg-gray-50 p-3">
          <div className="flex flex-row items-center">
            <img
              src="https://i.imgur.com/qHX7vY1.png"
              className="rounded"
              alt="Credit Card"
              width="70"
            />
            <div className="ml-3 flex flex-col">
              <span className="text-xl font-medium text-brand-forest">Credit Card</span>
              <span className="text-[#aba4a4]">1234 XXXX XXXX 2570</span>
            </div>
          </div>
          <input
            type="text"
            className="h-11 w-[73px] rounded border-2 border-[#eee] px-2 outline-none focus:border-[#304FFE]"
            placeholder="CVC"
          />
        </div>

        <div className="mt-2 flex items-center justify-between rounded bg-gray-50 p-3">
          <div className="flex flex-row items-center">
            <img
              src="https://i.imgur.com/qHX7vY1.png"
              className="rounded"
              alt="Debit Card"
              width="70"
            />
            <div className="ml-3 flex flex-col">
              <span className="text-xl font-medium text-brand-forest">Debit Card</span>
              <span className="text-[#aba4a4]">2344 XXXX XXXX 8880</span>
            </div>
          </div>
          <input
            type="text"
            className="h-11 w-[73px] rounded border-2 border-[#eee] px-2 outline-none focus:border-[#304FFE]"
            placeholder="CVC"
          />
        </div>

        <h6 className="mt-4 text-primary">ADD PAYMENT METHOD</h6>
        <div className="mt-2">
          <input
            type="text"
            className="h-[55px] w-full rounded border-2 border-[#eee] px-3 outline-none focus:border-[#304FFE]"
            placeholder="Email Address"
          />
        </div>
        <div className="mt-3">
          <button className="btn h-[70px] w-full rounded-lg text-xl" type="button">
            Proceed to payment <i className="fa fa-long-arrow-right text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpgradePlan;
